var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreanceicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79.3 70",
    style: {
      enableBackground: "new 0 0 79.3 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.8,52.1c-8.9-0.1-17.7-0.7-26.1-3.3C10.7,48,8,46.6,5.2,45.4C4.4,45,3.7,44.2,3,43.5c-1.9-2-1.8-4.2,0-6.2 c2-2.2,4.6-3.3,7.4-4.3c6-2.2,12.3-3.2,18.7-3.8c7-0.6,13.9-0.6,20.9,0c7,0.6,13.9,1.7,20.4,4.4c1.8,0.8,3.6,1.8,5.1,3.1 c2.8,2.3,2.8,5.1,0,7.5c-2.6,2.3-5.8,3.4-9,4.4C57.7,51.3,48.7,52,39.8,52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7,49.6c12.2,6,25,7.2,38,7.2c13,0,25.9-1.3,37.9-7.2c0,2.6,0.3,5.2-0.1,7.7c-0.2,1.3-1.2,2.6-2.3,3.6 c-2.6,2.3-5.8,3.4-9,4.3c-8.5,2.5-17.3,3.3-26.1,3.3c-9.2,0-18.2-0.8-27.1-3.3c-3.1-0.9-6-2-8.6-4c-1.8-1.4-2.9-3.1-2.7-5.5 C1.8,53.8,1.7,51.8,1.7,49.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 39.6,
    cy: 22.6,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6,
    cy: 13.7,
    r: 3.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.6,
    cy: 4.9,
    r: 3.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreanceicon2);
export default __webpack_public_path__ + "static/media/creance icon2.7fdd781a46b280727b2b00bb0ea8951d.svg";
export { ForwardRef as ReactComponent };